/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ExamCorrectExamMutationRequest,
  PostApiV1ExamCorrectExamMutationResponse,
  PostApiV1ExamCorrectExam400,
  PostApiV1ExamCorrectExam401,
  PostApiV1ExamCorrectExam500,
} from "../../types/examCorrectionDashboardController/PostApiV1ExamCorrectExam.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ExamCorrectExam } from "../../clients/examCorrectionDashboardController/postApiV1ExamCorrectExam.ts";

export const postApiV1ExamCorrectExamMutationKey = () =>
  [{ url: "/api/v1/exam/correct-exam" }] as const;

export type PostApiV1ExamCorrectExamMutationKey = ReturnType<
  typeof postApiV1ExamCorrectExamMutationKey
>;

export function postApiV1ExamCorrectExamMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1ExamCorrectExamMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1ExamCorrectExamMutationKey();
  return mutationOptions<
    PostApiV1ExamCorrectExamMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamCorrectExam400
      | PostApiV1ExamCorrectExam401
      | PostApiV1ExamCorrectExam500
    >,
    { data: PostApiV1ExamCorrectExamMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1ExamCorrectExam(data, config);
    },
  });
}

/**
 * @description Salva a correção de texto para uma resposta específica da prova enviada pelo usuário. **(Requer Authorization para autenticação)**
 * @summary Enviar correção da prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/correct-exam}
 */
export function usePostApiV1ExamCorrectExam<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ExamCorrectExamMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamCorrectExam400
        | PostApiV1ExamCorrectExam401
        | PostApiV1ExamCorrectExam500
      >,
      { data: PostApiV1ExamCorrectExamMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiV1ExamCorrectExamMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1ExamCorrectExamMutationKey();

  const baseOptions = postApiV1ExamCorrectExamMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1ExamCorrectExamMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamCorrectExam400
      | PostApiV1ExamCorrectExam401
      | PostApiV1ExamCorrectExam500
    >,
    { data: PostApiV1ExamCorrectExamMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1ExamCorrectExamMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamCorrectExam400
      | PostApiV1ExamCorrectExam401
      | PostApiV1ExamCorrectExam500
    >,
    { data: PostApiV1ExamCorrectExamMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ExamCorrectExamMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamCorrectExam400
      | PostApiV1ExamCorrectExam401
      | PostApiV1ExamCorrectExam500
    >,
    { data: PostApiV1ExamCorrectExamMutationRequest },
    TContext
  >;
}
